import { Injectable, OnDestroy } from '@angular/core';
import { Configuration } from './configuration.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppConfig implements OnDestroy {

  public config: Configuration;

  constructor(private http: HttpClient) {
  }

  public load(): Promise<any> {
    return this.http.get('assets/config/config.json')
      .toPromise()
      .then((config: Configuration) => this.config = config)
      .catch(() => {
        Promise.resolve();
      });
  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }
}
